import React from 'react';
import { Route } from 'react-router-dom';

import UpdateCampaignForm from '../campaign-editor/UpdateCampaignForm';
import DocumentTitle from '../generic/DocumentTitle';
import RedirectToEdit from '../layout/RedirectToEdit';
import ListCategorizedCampaigns from './ListCategorizedCampaigns';

function Routes() {
  return (
    <DocumentTitle title="Campaigns">
      <Route path="/campaigns" exact component={ListCategorizedCampaigns} />
      <Route path="/campaigns/:id/edit" component={UpdateCampaignForm} />
      <Route path="/campaigns/:id/show" render={RedirectToEdit} />
    </DocumentTitle>
  );
}

export default Routes;
